/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseList } from './UseCaseList';
import { UseCaseListFromJSON, UseCaseListFromJSONTyped, UseCaseListToJSON } from './UseCaseList';

/**
 *
 * @export
 * @interface PaginatedUseCaseListList
 */
export interface PaginatedUseCaseListList {
  /**
   *
   * @type {number}
   * @memberof PaginatedUseCaseListList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedUseCaseListList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedUseCaseListList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<UseCaseList>}
   * @memberof PaginatedUseCaseListList
   */
  results: Array<UseCaseList>;
}

/**
 * Check if a given object implements the PaginatedUseCaseListList interface.
 */
export function instanceOfPaginatedUseCaseListList(value: object): value is PaginatedUseCaseListList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedUseCaseListListFromJSON(json: any): PaginatedUseCaseListList {
  return PaginatedUseCaseListListFromJSONTyped(json, false);
}

export function PaginatedUseCaseListListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedUseCaseListList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(UseCaseListFromJSON),
  };
}

export function PaginatedUseCaseListListToJSON(value?: PaginatedUseCaseListList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(UseCaseListToJSON),
  };
}
